import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import {NotificationListAPI} from "./../../API/Publisher/NotificationAPI";
//import Sidebar from "./Common/Sidebar";
//import Header from "./Common/Header";
//import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";


const Notification = () =>{

    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    
    const perpagedata = 15;


    useEffect(() => {

        NotificationListAPI(setNotifications, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Notifications</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card crm-callers-card">
                        <div className="card-body">

                            <div className="table-responsive custom-table crm-callers-table-wrap caller-wrapper">
                                {loading ?
                                    <ContentLoader />
                                :
                                <table className="table" id="faqlist">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Lead Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Schedule Date & Time</th>
                                            <th>Sub-Disposition</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {
                                    notifications && notifications.length > 0  ?
                                        notifications.map(notification =>
                                        (

                                            <tr key={notification.id}>
                                                <td>
                                                    <Link to={`/publisher/lead-profile/${notification.leadid}`} className="">{notification.leadname}</Link>
                                                </td>
                                                <td>{notification.email}</td>
                                                <td>{notification.contact}</td>
                                                <td>{moment(notification.display_date).format('DD-MM-YYYY')} {notification.display_time}</td>
                                                <td>
                                                    {notification.subdispnaame !== "" && notification.subdispnaame!== null ?
                                                        (notification.subdispnaame)
                                                    :
                                                        <>-</>
                                                    }

                                                </td>
                                                <td>
                                                    {notification.is_closed === 1 ?
                                                        <span class="badge bg-success">Completed</span>
                                                    :
                                                        <span class="badge bg-info">Pending</span>
                                                    }
                                                </td>
                                            </tr>
                                        ))

                                    :

                                        <tr>
                                            <td colSpan="6">
                                                <center><p>No record found...</p></center>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>

                    {pagecount > 1 ?
                    <div className="row pagination-section">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>
        </div>
    </Layout>
    )
}

export default Notification;
